import { render, staticRenderFns } from "./TextContentBlockForm.vue?vue&type=template&id=37652868&"
import script from "./TextContentBlockForm.vue?vue&type=script&lang=ts&"
export * from "./TextContentBlockForm.vue?vue&type=script&lang=ts&"
import style0 from "./TextContentBlockForm.vue?vue&type=style&index=0&id=37652868&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports